import {NgModule} from '@angular/core';
import {RouterModule, Routes} from '@angular/router';
import {LoginComponent} from './components/login/login.component';
import {HomeComponent} from './components/home/home.component';
import {RouteGuardService} from './services/RouteGuard.service';
import {Paths} from './utils/Paths';
import {CommonModule} from '@angular/common';
import {DashboardComponent} from "./components/dashboard/dashboard.component";
import {EmptyComponent} from "./components/empty/empty.component";
import {PartitionComponent} from "./components/registry/partition/partition.component";
import {UserComponent} from "./components/registry/user/user.component";
import {DeviceTypeComponent} from "./components/registry/device-type/device-type.component";
import {ChartsComponent} from "./components/charts/charts.component";
import {GatewayTypeComponent} from "./components/registry/gateway-type/gateway-type.component";
import {GatewayDeviceComponent} from "./components/registry/gateway-device/gateway-device.component";
import {DiagnosticComponent} from "./components/alarm/diagnostic/diagnostic.component";
import {AlertComponent} from "./components/alarm/alert/alert.component";
import {ResetPasswordComponent} from "./components/reset-password/reset-password.component";
import {VirtualMeasuresComponent} from "./components/registry/virtual-measures/virtual-measures.component";
import {NotFoundComponent} from "./components/not-found/not-found.component";
import {postLoginResolver} from "./services/post-login.resolver";
import {UserReportComponent} from "./components/report/user-report.component";

const routes: Routes = [
  {
    path: Paths.LOGIN,
    pathMatch: 'full',
    component: LoginComponent,
  },
  {
    path: Paths.RESET_PASSWORD,
    pathMatch: 'full',
    component: ResetPasswordComponent,
  },
  {
    path: Paths.HOME,
    component: HomeComponent,
    canActivate: [
      RouteGuardService
    ],
    resolve: {init: postLoginResolver},
    children: [
      {
        path: Paths.PARTITIONS,
        component: PartitionComponent,
        canActivate: [
          RouteGuardService
        ]
      },
      {
        path: Paths.USERS,
        component: UserComponent,
        canActivate: [
          RouteGuardService
        ]
      },
      {
        path: Paths.DEVICE_TYPES,
        component: DeviceTypeComponent,
        canActivate: [
          RouteGuardService
        ]
      },
      {
        path: Paths.GATEWAYS,
        component: GatewayDeviceComponent,
        canActivate: [
          RouteGuardService
        ]
      },
      {
        path: Paths.GATEWAY_TYPES,
        component: GatewayTypeComponent,
        canActivate: [
          RouteGuardService
        ]
      },
      {
        path: Paths.VIRTUAL_METRICS,
        component: VirtualMeasuresComponent,
        canActivate: [
          RouteGuardService
        ]
      },
      {
        path: Paths.DASHBOARD,
        component: DashboardComponent,
        canActivate: [
          RouteGuardService
        ]
      },
      {
        path: Paths.CHARTS,
        component: ChartsComponent,
        canActivate: [
          RouteGuardService
        ]
      },
      {
        path: Paths.REPORTS,
        component: UserReportComponent,
        canActivate: [
          RouteGuardService
        ]
      },
      {
        path: Paths.DIAGNOSTICS,
        component: DiagnosticComponent,
        canActivate: [
          RouteGuardService
        ]
      },
      {
        path: Paths.ALERTS,
        component: AlertComponent,
        canActivate: [
          RouteGuardService
        ]
      },
      {
        path: Paths.EMPTY,
        component: EmptyComponent,
        canActivate: [
          RouteGuardService
        ]
      },
      {path: '', redirectTo: Paths.DASHBOARD, pathMatch: 'full'},
      {path: '**', component: NotFoundComponent}
    ]
  },
  {path: '**', component: NotFoundComponent}
];

@NgModule({
  imports: [CommonModule, RouterModule.forRoot(routes, {})],
  exports: [RouterModule]
})
export class AppRoutingModule {
}
